/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_LinkInputs */

const en_invite_link = /** @type {(inputs: Invite_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite link`)
};

const de_invite_link = /** @type {(inputs: Invite_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einladungslink`)
};

/**
* | output |
* | --- |
* | "Invite link" |
*
* @param {Invite_LinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const invite_link = /** @type {((inputs?: Invite_LinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_LinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_invite_link(inputs)
	return en_invite_link(inputs)
});